export const BREAKPOINTS = {
  XXS: 480, // 30rem from SCSS
  XS: 600, // 37.5rem from SCSS
  SMALL: 768, // 48rem from SCSS
  MEDIUM: 960, // 60rem from SCSS
  LARGE: 1280, // 80rem from SCSS
  XLARGE: 1440, // 90rem from SCSS
} as const;

// Define breakpoints type (matching SCSS breakpoints)
export type Breakpoint = 'XXS' | 'XS' | 'SMALL' | 'MEDIUM' | 'LARGE' | 'XLARGE';
